import { Button } from '@hakimo-ui/shared/ui-base';

interface Props {
  isUpdating: boolean;
  submitLoading: boolean;
  canApply: boolean;
  hasAnySelection: boolean;
  onSubmit: () => void;
  onCancel: () => void;
  onDisableAll: () => void;
}

export function MonitoringTenantsFooter({
  isUpdating,
  submitLoading,
  canApply,
  hasAnySelection,
  onSubmit,
  onCancel,
  onDisableAll,
}: Props) {
  return (
    <div className="flex gap-2 border-t px-8 py-4 dark:border-gray-600">
      <Button
        variant="primary"
        onClick={onSubmit}
        loading={submitLoading}
        disabled={isUpdating || !canApply}
      >
        Submit
      </Button>
      <Button variant="outline" onClick={onCancel} disabled={isUpdating}>
        Cancel
      </Button>
      <Button
        variant="error"
        className="ml-auto"
        onClick={onDisableAll}
        disabled={isUpdating || !hasAnySelection}
      >
        Disable All
      </Button>
    </div>
  );
}

export default MonitoringTenantsFooter;
